import React, { useEffect, useRef, useState } from "react";
import { playSound } from "../lib/sound.js";

const CONFETTI_COLORS = ["bg-magenta", "bg-cyan", "bg-gold", "bg-lime"];
const VISIBLE_MS = 2200;

function buildConfetti(count) {
  return Array.from({ length: count }, (_, i) => ({
    id: i,
    left: Math.random() * 100,
    delay: Math.random() * 0.4,
    duration: 1 + Math.random() * 0.6,
    color: CONFETTI_COLORS[i % CONFETTI_COLORS.length],
  }));
}

// A brief, non-blocking overlay fired once when a level's Debrief screen
// finishes saving. `show` is meant to be wired to the same `saved` boolean
// every DebriefStage already tracks — it fires once per false→true
// transition rather than on every render, so retries (which remount the
// stage from scratch) still trigger it fresh.
export default function Celebration({ show, levelUp = false }) {
  const [visible, setVisible] = useState(false);
  const [pieces, setPieces] = useState([]);
  const alreadyFired = useRef(false);

  useEffect(() => {
    if (!show) {
      alreadyFired.current = false;
      return undefined;
    }
    if (alreadyFired.current) return undefined;
    alreadyFired.current = true;

    setPieces(buildConfetti(levelUp ? 28 : 18));
    setVisible(true);
    playSound(levelUp ? "levelup" : "success");

    const timer = setTimeout(() => setVisible(false), VISIBLE_MS);
    return () => clearTimeout(timer);
  }, [show, levelUp]);

  if (!visible) return null;

  return (
    <div className="pointer-events-none fixed inset-0 z-[65] overflow-hidden">
      {pieces.map((p) => (
        <span
          key={p.id}
          className={`absolute top-0 h-3 w-3 ${p.color} animate-confettiFall`}
          style={{ left: `${p.left}%`, animationDelay: `${p.delay}s`, animationDuration: `${p.duration}s` }}
        />
      ))}
      <div className="absolute inset-0 flex items-center justify-center px-4">
        <div
          className={`panel animate-popIn px-6 py-4 text-center ${
            levelUp ? "border-gold shadow-glow-gold" : "border-lime shadow-glow-lime"
          }`}
        >
          <p className={`pixel-heading text-sm sm:text-lg ${levelUp ? "text-gold" : "text-lime"}`}>
            {levelUp ? "LEVEL UP!" : "LEVEL COMPLETE"}
          </p>
        </div>
      </div>
    </div>
  );
}
